import { server_address } from "./Config";
import { RefreshToken, redirectToLogin } from "./TokenOperations";

// Every authenticated backend route re-validates the JWT by comparing the
// decoded username against req.body.username, so `body` must include it
// whenever `token` is passed - callers already do this today.
export async function apiRequest(path, { method = 'POST', token, body, retried = false } = {}) {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
  if (token) headers.token = token;

  const rawResponse = await fetch(server_address + path, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const content = await rawResponse.json();

  if (content.status === 'expired' && !retried) {
    const refreshed = await RefreshToken();
    if (refreshed === 'expired') {
      // The refresh token is gone too - nothing left to do but log in again.
      redirectToLogin();
      return { status: 'fail', message: 'Your session has expired. Please login again.' };
    }
    if (refreshed !== 'ok') {
      return { status: 'fail', message: "The token couldn't be refreshed." };
    }
    const accessToken = localStorage.getItem('accessToken');
    return apiRequest(path, { method, token: accessToken, body, retried: true });
  }

  return content;
}
